var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-tree"},[_c('el-tree',_vm._b({attrs:{"data":_vm.treeData,"render-content":_vm.renderContent,"lazy":_vm.lazy,"load":_vm.load,"filter-node-method":_vm.filterNodeMethod}},'el-tree',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }